import { useContext, useEffect } from "react";
import OLVectorLayer from "ol/layer/Vector";
import MapContext from "views/OLMap/Map/MapContext";
import vectorStyles from "../vectorstyle";

const VectorLayer = ({ source, className, style, zIndex = 0, ...props }) => {
  const { map } = useContext(MapContext);
  useEffect(() => {
    if (!map) return;
    const styleFunction = (feature) => vectorStyles[feature.getGeometry().getType()];
    const vectorLayer = new OLVectorLayer({
      source,
      style: style || styleFunction,
      className,
      ...props,
    });
    map.addLayer(vectorLayer);
    vectorLayer.setZIndex(zIndex);
    // eslint-disable-next-line consistent-return
    return () => {
      if (map) {
        map.removeLayer(vectorLayer);
      }
    };
  }, [map]);
  return null;
};
export default VectorLayer;
